/**
 * List Bounded Contexts Handler
 * 
 * CQRS Query Handler that delegates to BoundedContextQueryService.
 * Thin adapter layer for read operations.
 */

import { injectable, inject } from 'inversify';
import { IQueryHandler, IPaginatedResult } from '@swoft/core';
import { ListBoundedContextsQuery, BoundedContextDto } from '../queries/GetBoundedContextQuery';
import { BoundedContextQueryService } from '../services/BoundedContextQueryService';
import { DDD_SYMBOLS } from '../../../../infrastructure/di/DDD_SYMBOLS';

@injectable()
export class ListBoundedContextsHandler implements IQueryHandler<ListBoundedContextsQuery, IPaginatedResult<BoundedContextDto>> {
  constructor(
    @inject(DDD_SYMBOLS.BoundedContextQueryService) private boundedContextQueryService: BoundedContextQueryService
  ) {}

  async handle(query: ListBoundedContextsQuery): Promise<IPaginatedResult<BoundedContextDto>> {
    return await this.boundedContextQueryService.listBoundedContexts(query.params);
  }
}